import { useEffect, useMemo } from "react";
import { JsonParam, useQueryParams } from "use-query-params";
import { counterpartiesUrlFiltersSchema } from "./lib/counterpartiesUrl";
import { CounterpartyDirectoryViewRow } from "./counterpartyDirectoryViewTypes";

export function useCounterpartyUrlSelection({
    rows,
    setSelectedRow,
    isLoading,
}: {
    rows: CounterpartyDirectoryViewRow[];
    setSelectedRow: (row: CounterpartyDirectoryViewRow | null) => void;
    isLoading: boolean;
}) {
    const [{ filters: urlFilters }, setQueryParams] = useQueryParams({
        filters: JsonParam,
    });

    const parsedUrlFilters = useMemo(() => {
        if (!urlFilters) {
            return undefined;
        }
        const { data, success: isSuccess } =
            counterpartiesUrlFiltersSchema.safeParse(urlFilters);
        return isSuccess ? data : undefined;
    }, [urlFilters]);

    useEffect(() => {
        const counterpartyId = parsedUrlFilters?.counterpartyId;
        if (!counterpartyId || isLoading) {
            return;
        }

        const row = rows.find(
            (directoryRow) => directoryRow.counterparty?.id === counterpartyId,
        );
        if (!row) {
            return;
        }

        setQueryParams({ filters: undefined }, "replaceIn");
        setSelectedRow(row);
    }, [
        parsedUrlFilters?.counterpartyId,
        isLoading,
        rows,
        setSelectedRow,
        setQueryParams,
    ]);
}
